import { graphql } from '@graphql/__generated'

export const GET_ZAPIER_INTEGRATION_STATUS = graphql(`
  query getZapierIntegrationStatus($name: String!) {
    getZapierIntegrationStatus(name: $name) {
      connected
      hasApiToken
      tokenLastFour
      createdAt
      activeSubscriptionCount
    }
  }
`)

export const CREATE_ZAPIER_API_TOKEN = graphql(`
  mutation createZapierApiToken($name: String!) {
    createZapierApiToken(name: $name) {
      success
      token
      tokenLastFour
      createdAt
      error
    }
  }
`)

export const REVOKE_ZAPIER_INTEGRATION = graphql(`
  mutation revokeZapierIntegration($name: String!) {
    revokeZapierIntegration(name: $name) {
      success
    }
  }
`)
